<div id="app-background" class="w-100 h-100">
<div *ngIf="!appState.appExitedSubject.value; else show_app_exited" class="pt-2 app-content">
  <app-notification-panel></app-notification-panel>
  <div class="container-fluid">
  <router-outlet></router-outlet>
  </div>
</div>

<ng-template #show_app_exited>
  <div class="container pt-5">
    <h2>Testbed Application Shutdown</h2>
    <div *ngIf="appState.appExitedMsg" class="alert alert-danger">{{appState.appExitedMsg}}</div>
  </div>
</ng-template>
</div>
